import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useSearchParams, useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import { MuiOtpInput } from 'mui-one-time-password-input';
import Helpers from '../utility/Helpers';
import {
  tokenLogin,
  doLogin,
  Initiate2FAOTP,
} from '../services/AccountService';
import { GetQuestions } from '../services/Service';
import Loader from './../common/Loader';

function Login(props) {
  const navigate = useNavigate();
  let dispatch = useDispatch();
  let textInputUser = React.createRef();
  let textInputPassword = React.createRef();
  const [isLoading, setIsLoading] = React.useState(false);
  const [userEmail, setUserEmail] = useState('');
  const [password, setPassword] = useState('');
  const [hasInvalidateEmail, setHasInvalidateEmail] = useState(false);
  const [passwordConfirmed, setPasswordConfirmed] = React.useState(false);
  const [otp, setOtp] = React.useState('');
  const [timerOn] = React.useState(true);
  const [timerDisplay, setTimerDisplay] = React.useState(false);
  const [timeRemaining, setTimeRemaining] = React.useState('');
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const securitytoken = searchParams.get('token');
    if (securitytoken === null || securitytoken === '') return;
    let token = '';
    tokenLogin(securitytoken)
      .then((res) => {
        var responsedata = res.data;
        if (responsedata !== undefined) {
          setIsLoading(false);
          setPasswordConfirmed(true);
          setTimerDisplay(true);
          timer(parseInt(responsedata.time));
          Helpers.handleSuccess(res.message);
          return;
        }
        token = res.token;
        sessionStorage.setItem('userToken', token);
        sessionStorage.setItem('tokenDateTime', new Date());
        sessionStorage.setItem('userName', res.profile.farstName);
        sessionStorage.setItem('userroles', JSON.stringify(res.profile.roles));
        sessionStorage.setItem('returnUrl', res.profile.returnUrl);
        sessionStorage.setItem('securitytoken', securitytoken);
        const userConfig = {
          routes: ['all'],
          navigation: [],
          userName: res.profile.farstName,
          userEmail: res.profile.email,
          userID: res.profile.userId,
          userRole: res.profile.roles,
          userToken: token,
        };
        dispatch({
          type: 'USER_LOGIN',
          userConfig,
        });

        GetQuestions()
          .then((qres) => {
            sessionStorage.setItem('questionData', JSON.stringify(qres.data));
          })
          .catch((error) => {
            setIsLoading(false);
            Helpers.handleError(error);
          });

        setTimeout(navigate('/dashboard'), 500);
      })
      .catch((error) => {
        setIsLoading(false);
      });

    for (var i = 0; i < sessionStorage.length; i++) {
      var a = sessionStorage.key(i);
      sessionStorage.removeItem(a);
    }
  }, []);

  function timer(remaining) {
    var m = Math.floor(remaining / 60);
    var s = remaining % 60;
    m = m < 10 ? '0' + m : m;
    s = s < 10 ? '0' + s : s;
    setTimeRemaining(m + ':' + s);
    remaining -= 1;

    if (remaining >= 0 && timerOn) {
      setTimeout(function () {
        timer(remaining);
      }, 1000);
      return;
    }
    if (!timerOn) {
      // Do validate stuff here
      return;
    }
    // Do timeout stuff here
    setTimerDisplay(false);
  }
  const handleEmailChange = (val) => {
    setUserEmail(val.target.value);
  };

  const handlePasswordChange = (val) => {
    setPassword(val.target.value);
  };

  const handleOTPChange = (newValue) => {
    setOtp(newValue);
  };

  const tryLogin = async () => {
    if (!passwordConfirmed) {
      if (textInputUser.current.value === '') {
        Helpers.handleError('User Email is required');
        textInputUser.current.focus();
        return;
      } else if (!Helpers.isValidEmail(textInputUser.current.value)) {
        Helpers.handleError('Input a valid email');
        textInputUser.current.focus();
        return;
      }
      if (textInputPassword.current.value === '') {
        Helpers.handleError('Password is required');
        textInputPassword.current.focus();
        return;
      }
    }
    let token = '';
    setIsLoading(true);
    await doLogin(userEmail, password, otp)
      .then((res) => {
        var responsedata = res.data;
        if (responsedata !== undefined) {
          setIsLoading(false);
          setPasswordConfirmed(true);
          setTimerDisplay(true);
          timer(parseInt(responsedata.time));
          Helpers.handleSuccess(res.message);
          return;
        }
        //debugger
        //setIsLoading(false);
        token = res.token;
        sessionStorage.setItem('userToken', token);
        sessionStorage.setItem('tokenDateTime', new Date());
        sessionStorage.setItem(
          'userName',
          res.profile.farstName + ' ' + res.profile.lastName
        );
        sessionStorage.setItem('userroles', JSON.stringify(res.profile.roles));
        const userConfig = {
          routes: ['all'],
          navigation: [],
          userName: res.profile.name,
          userEmail: res.profile.email,
          userID: res.profile.userId,
          userRole: res.profile.roles,
          userToken: token,
        };
        dispatch({
          type: 'USER_LOGIN',
          userConfig,
        });

        GetQuestions()
          .then((qres) => {
            sessionStorage.setItem('questionData', JSON.stringify(qres.data));
          })
          .catch((error) => {
            setIsLoading(false);
            Helpers.handleError(error);
          });

        setTimeout(navigate('/dashboard'), 500);
      })
      .catch((error) => {
        setIsLoading(false);
        setHasInvalidateEmail(error.includes('EE0'));
        Helpers.handleError(error.replace(':EE0', '').replace(':EU0', ''));
      });
  };

  const tryResetPassword = async () => {
    sessionStorage.setItem('otpInitiationType', '2');
    sessionStorage.setItem('userEmail', '');
    setTimeout(navigate('/initiateotp'), 500);
  };

  const tryValidateEmail = async () => {
    sessionStorage.setItem('otpInitiationType', '1');
    sessionStorage.setItem('userEmail', '');
    setTimeout(navigate('/initiateotp'), 500);
  };

  const resendOTP = async () => {
    setIsLoading(true);
    await Initiate2FAOTP(userEmail, 3)
      .then((res) => {
        var responsedata = res.data;
        Helpers.handleSuccess(res.message);
        setTimerDisplay(true);
        timer(parseInt(responsedata.time));
        setIsLoading(false);
        return;
      })
      .catch((error) => {
        Helpers.handleError(error);
        setIsLoading(false);
      });
  };

  const cancelAction = async () => {
    setUserEmail('');
    setPassword('');
    setPasswordConfirmed(false);
    setOtp('');
  };

  const getHeadingText = () => {
    if (!passwordConfirmed) return 'LOGIN';
    else return 'OTP VERIFICATION';
  };
  
  const getSubHeadingText = () => {
    if (!passwordConfirmed) return 'Please sign in to continue';
    else return "We've just sent a 6-digit code to your email: " + userEmail;
  };
  // function GradientCircularProgress() {
  //       return (
  //         <React.Fragment>
  //           <svg width={0} height={0}>
  //             <defs>
  //               <linearGradient id="my_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
  //                 <stop offset="0%" stopColor="#e01cd5" />
  //                 <stop offset="100%" stopColor="#1CB5E0" />
  //               </linearGradient>
  //             </defs>
  //           </svg>
  //           <CircularProgress sx={{ 'svg circle': { stroke: 'url(#my_gradient)' } }} />
  //         </React.Fragment>
  //       );
  //     };
  return (
    <>
      <Box className="bg-login-image">
        <AppBar
          position="fixed"
          sx={{
            width: '100%',
          }}
        >
          <Toolbar>
            <Box
              component="img"
              alt="Org Image"
              src={process.env.PUBLIC_URL + '/images/blank.png'}
            />
            <Box
              component="img"
              sx={
                {
                  //height: 80,
                  //maxHeight: { xs: 100, md: 90 },
                }
              }
              alt="Org Image"
              src={process.env.PUBLIC_URL + '/images/decama-logo.png'}
            />

            <Box
              component="img"
              alt="Org Image"
              src={process.env.PUBLIC_URL + '/images/blank.png'}
            />
          </Toolbar>
        </AppBar>
        <div className="pageContainer">
          <CssBaseline />
          {/* <Box
                  sx={{
                    marginTop: 8,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    paddingLeft:'20px',
                    paddingRight:'20px'
                  }}
                >

                    <Box noValidate className="loginbox" sx={{ mt: 1 }}>
                      <div style={{fontWeight:'500', fontSize:'28px'}}>{getHeadingText()}</div>
                      <div style={{fontWeight:'500', fontSize:'16px'}}>{getSubHeadingText()}</div>
                      <div className="clear-height">&nbsp;</div>
                      {!passwordConfirmed &&(<>
                        <TextField
                          margin="normal"
                          required
                          fullWidth
                          id="email"
                          name="email"
                          type="email"
                          value={userEmail}
                          placeholder="Email Address"
                          autoComplete="email"
                          autoFocus
                          inputRef={textInputUser}
                         
                          style={{borderLeft:'1px'}}
                          onChange={handleEmailChange}
                        />
                        <TextField
                          margin="normal"
                          required
                          fullWidth
                          name="password"
                          type="password"
                          id="password"
                          value={password}
                          placeholder="Password"
                          autoComplete="current-password"
                          inputRef={textInputPassword}
                          onChange={handlePasswordChange}
                        /></>)}
                        {(passwordConfirmed) &&(<>
                                                 <div className=".css-md26zr-MuiInputBase-root-MuiOutlinedInput-root">
                                                  <MuiOtpInput margin="normal" length={6} id="otptext" name="otptext" value={otp} onChange={handleOTPChange} />
                                                  </div></>
                                                  )}
                        <Button
                          type="button"
                          fullWidth
                         
                          sx={{ mt: 3, mb: 2, color:'white' }}
                          onClick={() => {
                            tryLogin();
                          }}
                          className="login-screen-button"
                        >
                          <span style={{fontSize:'18px'}}>{passwordConfirmed?"CONFIRM":"LOGIN"}</span>
                        </Button>
                        <Grid container>
                        <div className="clear-height">&nbsp;</div>
                        </Grid>
                      </Box>
                      {!passwordConfirmed &&(<>
                      <Link 
                      sx={{display:!hasInvalidateEmail? 'block':'none' }}
                      onClick={() => {
                            tryResetPassword();
                          }}>
                            Reset Password
                          </Link>
                         {hasInvalidateEmail &&( <Link 
                      
                      onClick={() => {
                        tryValidateEmail();
                          }}>
                            Validate your email
                          </Link>)}
                          </>)}
                          {passwordConfirmed &&(<><Link 
                      sx={{display:!timerDisplay? 'block':'none' }}
                      onClick={() => {
                        resendOTP();
                          }}>
                            Resend Code
                          </Link>
                          <Typography sx={{ display: timerDisplay? 'block':'none', fontSize:'16px',color:' #58585a' }} >Resend in:{timeRemaining}</Typography>

                          </>)}
              </Box> */}
        </div>
        {passwordConfirmed && (
          <Box
            width="100%"
            display="flex"
            justifyContent="center"
            className="bottom-mini-device"
          >
            <Link
              onClick={() => {
                cancelAction();
              }}
              justifyContent="center"
              style={{
                textDecoration: 'none',
                color: '#e26f8e',
                fontSize: '20px',
              }}
            >
              Cancel
            </Link>
          </Box>
        )}
      </Box>
      {/* {isLoading &&(
                <Box 
                width='100%'
                  display='flex'
                  justifyContent='center'
                  position= 'absolute'
                  top='50%'
                  zIndex='tooltip' 
                  transform='translate(-50%, -50%)'
                  sx={{ opacity:'0.4',
                   
                   }}>
                    <GradientCircularProgress />
                </Box>
              )} */}
      <Loader isLoading={isLoading} />
    </>
  );
}
export default Login;
